export const flattenMediaQueryList = e => ({
	type: 'query-list',
	mediaQueries: e.mediaQueries.map(e => flattenMediaQuery(e))
})
export const flattenMediaQuery = e =>
	e.mediaCondition
		? {
				type: 'query',
				prefix: e.prefix,
				mediaType: e.mediaType,
				mediaCondition: flattenMediaCondition(e.mediaCondition)
		  }
		: e
export const flattenMediaCondition = e => {
	const o = []
	for (const t of e.children)
		if ('condition' === t.type) {
			const i = flattenMediaCondition(t)
			void 0 === i.operator && 1 === i.children.length
				? o.push(i.children[0])
				: i.operator !== e.operator || ('and' !== i.operator && 'or' !== i.operator)
				? o.push(i)
				: o.push(...i.children)
		} else o.push(t)
	if (1 === o.length) {
		const t = o[0]
		if ('condition' === t.type) {
			if (void 0 === e.operator) return t
			if ('not' === e.operator && 'not' === t.operator)
				return {type: 'condition', children: t.children}
		}
	}
	return {type: 'condition', operator: e.operator, children: o}
}
